// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2021 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React from 'react';
import styled from 'styled-components';
import { Icon } from './../Icon';

const AaSvgIcon = styled(Icon)`
  width: 1.7813rem;
  height: 1.125rem;
`;

const AntiTrackYellowSvg = styled(Icon)`
  width: 4rem;
  height: 4rem;
`;

export const AaIcon: React.FunctionComponent<React.HTMLAttributes<HTMLElement>> = () => (
  <AaSvgIcon className='aa-icon' viewBox='0 0 29 18'>
    <path
      d='M14.6691 18C15.4595 18 15.8786 17.664 16.142 16.824L17.4832 13.08H24.3208L25.65 16.824C25.9134 17.664 26.3326 18 27.1229 18C27.9611 18 28.5 17.496 28.5 16.704C28.5 16.416 28.4521 16.176 28.3443 15.852L23.0275 1.5C22.6683 0.492 21.9977 0 20.908 0C19.8662 0 19.1836 0.492 18.8363 1.488L13.4956 15.912C13.3878 16.224 13.3399 16.476 13.3399 16.728C13.3399 17.52 13.8429 18 14.6691 18ZM18.1658 10.86L20.8721 3.06H20.9439L23.6502 10.86H18.1658ZM1.22143 17.964C1.84412 17.964 2.22731 17.64 2.45483 16.896L3.31702 14.316H7.97521L8.82542 16.908C9.05294 17.664 9.44811 17.964 10.0947 17.964C10.8132 17.964 11.3042 17.508 11.3042 16.824C11.3042 16.548 11.2443 16.272 11.1366 15.96L7.50819 6.24C7.16092 5.292 6.55021 4.836 5.62815 4.836C4.74202 4.836 4.14328 5.28 3.79601 6.24L0.167647 15.96C0.059874 16.248 0 16.56 0 16.824C0 17.532 0.467017 17.964 1.22143 17.964ZM3.89181 12.444L5.49643 7.44H5.75987L7.38845 12.444H3.89181Z'
      fill='#242424'
    />
  </AaSvgIcon>
);

export const AntiTrackYellowIcon: React.FunctionComponent<
  React.HTMLAttributes<HTMLElement>
> = () => (
  <AntiTrackYellowSvg viewBox='0 0 64 64' data-testid='antiTrackYellowIcon'>
    <g clipPath='url(#clip0_588_16991)'>
      <path
        d='M14.9299 0C6.68435 0 0 6.68435 0 14.9299V49.0701C0 57.3156 6.68435 64 14.9299 64H49.0701C57.3156 64 64 57.3156 64 49.0701V14.9299C64 6.68435 57.3156 0 49.0701 0H14.9299Z'
        fill='#FEEB29'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.5584 13.2012L25.3966 13.2012C24.6305 13.2012 23.8957 13.5055 23.354 14.0472L14.0472 23.354C13.5055 23.8958 13.2012 24.6305 13.2012 25.3966L13.2012 38.5584C13.2012 39.3245 13.5055 40.0593 14.0472 40.601L23.354 49.9078C23.8957 50.4495 24.6305 50.7539 25.3966 50.7539H38.5584C39.3245 50.7539 40.0593 50.4495 40.601 49.9078L49.9078 40.601C50.4495 40.0593 50.7538 39.3245 50.7538 38.5584V25.3966C50.7538 24.6305 50.4495 23.8958 49.9078 23.354L40.601 14.0472C40.0593 13.5055 39.3245 13.2012 38.5584 13.2012ZM25.3966 10.3125C23.8644 10.3125 22.3949 10.9212 21.3114 12.0046L12.0046 21.3114C10.9212 22.3949 10.3125 23.8644 10.3125 25.3966V38.5584C10.3125 40.0907 10.9212 41.5601 12.0046 42.6436L21.3114 51.9504C22.3949 53.0338 23.8644 53.6425 25.3966 53.6425H38.5584C40.0906 53.6425 41.5601 53.0338 42.6436 51.9504L51.9504 42.6436C53.0338 41.5601 53.6425 40.0906 53.6425 38.5584V25.3966C53.6425 23.8644 53.0338 22.3949 51.9504 21.3114L42.6436 12.0046C41.5601 10.9212 40.0906 10.3125 38.5584 10.3125H25.3966Z'
        fill='#242424'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M42.8098 31.978C42.8098 37.9607 37.9599 42.8106 31.9773 42.8106C25.9946 42.8106 21.1447 37.9607 21.1447 31.978C21.1447 25.9954 25.9946 21.1455 31.9773 21.1455C37.9599 21.1455 42.8098 25.9954 42.8098 31.978ZM31.9773 39.8562C36.3283 39.8562 39.8554 36.329 39.8554 31.978C39.8554 27.627 36.3283 24.0999 31.9773 24.0999C27.6262 24.0999 24.0991 27.627 24.0991 31.978C24.0991 36.329 27.6262 39.8562 31.9773 39.8562Z'
        fill='#242424'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.09 31.9782C16.09 30.9811 16.8983 30.1728 17.8954 30.1728H21.5063C22.5034 30.1728 23.3117 30.9811 23.3117 31.9782C23.3117 32.9753 22.5034 33.7836 21.5063 33.7836H17.8954C16.8983 33.7836 16.09 32.9753 16.09 31.9782Z'
        fill='#242424'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.6432 31.9782C40.6432 30.9811 41.4516 30.1728 42.4487 30.1728L46.0595 30.1728C47.0566 30.1728 47.8649 30.9811 47.8649 31.9782C47.8649 32.9753 47.0566 33.7836 46.0595 33.7836L42.4487 33.7836C41.4516 33.7836 40.6432 32.9753 40.6432 31.9782Z'
        fill='#242424'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.9774 16.09C32.9745 16.09 33.7828 16.8983 33.7828 17.8954L33.7828 21.5063C33.7828 22.5034 32.9745 23.3117 31.9774 23.3117C30.9803 23.3117 30.172 22.5034 30.172 21.5063L30.172 17.8954C30.172 16.8983 30.9803 16.09 31.9774 16.09Z'
        fill='#242424'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.9774 40.644C32.9745 40.644 33.7828 41.4524 33.7828 42.4495L33.7828 46.0603C33.7828 47.0574 32.9745 47.8657 31.9774 47.8657C30.9803 47.8657 30.172 47.0574 30.172 46.0603L30.172 42.4495C30.172 41.4524 30.9803 40.644 31.9774 40.644Z'
        fill='#242424'
      />
      <circle cx='31.9777' cy='31.9777' r='2.88867' fill='#242424' />
    </g>
  </AntiTrackYellowSvg>
);
